import dayjs from 'dayjs'
import { getFutureDate } from '../../common/Utils/Utils';


export const TO_ACCOUNT_TYPE_DEFAULT = "CHITTY";
export const TO_ACCOUNT_TYPES = {
    CHITTY:"CHITTY"
};
export const TO_ACCOUNT_TYPE_OPTIONS = [
    { key: "CHITTY", value: "CHITTY" },
];

export const MODAL_TYPES = {
  CREATE_STANDING_INSTRUCTION: "CREATE_STANDING_INSTRUCTION",
  STANDING_INSTRUCTION_DISCLAIMER: "STANDING_INSTRUCTION_DISCLAIMER",
  SI_CANCEL_CONFIRMATION: "SI_CANCEL_CONFIRMATION",
}
export const MODAL_TITLES = {
  CREATE_STANDING_INSTRUCTION: "Create Standing Instruction Request",
  STANDING_INSTRUCTION_DISCLAIMER: "Standing Instruction Disclaimer",
  SI_CANCEL_CONFIRMATION: "Cancel Standing Instruction",
}

export const SOURCE_ACCOUNT_TYPE = "SUGAMA"

export const SI_CANCEL_CONFIRMATION_MSG = "Are you sure you want to cancel this Standing Instruction?"

export const SUGMA_STANDING_INSTRUCTION_FORM_FIELDS = [
    {
      name: "account_no",
      label: "Account Number",
      type: "text",
      placeholder: "Enter Account Number",
      disabled: true,
    },
    {
      name: "source_account_type",
      label: "Source Account Type",
      type: "text",
      placeholder: "Enter Source Account Type",
      disabled: true,
    },
    {
      name: "to_account_type",
      label: "To Account Type",
      type: "select",
      placeholder: "Enter To Account Type",
      disabled: true,
      options: TO_ACCOUNT_TYPE_OPTIONS,
    },
  ]

export const SUGAMA_SI_CHITTY_FIELDS = [
  {
    name: "branch_id",
    label: "Branch",
    type: "select",
    placeholder: "Select Branch",
    disabled: false,
  },
  {
    name: "chitty_reg_no",
    label: "Chit No",
    type: "select",
    placeholder: "Select Chit No",
    disabled: false,
  },
  {
    name: "chittal_no",
    label: "Chittal No",
    type: "select",
    placeholder: "Select Chittal No",
    disabled: false,
  }
]